import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const LoanVolumeConversionChart: React.FC = () => {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        type: 'bar',
        label: 'Applications',
        data: [1150, 1180, 1200, 1280, 1300, 1250],
        backgroundColor: '#8b5cf6',
        borderColor: '#8b5cf6',
        borderWidth: 0,
        yAxisID: 'y'
      },
      {
        type: 'bar',
        label: 'Funded',
        data: [300, 320, 315, 335, 340, 330],
        backgroundColor: '#10b981',
        borderColor: '#10b981',
        borderWidth: 0,
        yAxisID: 'y'
      },
      {
        type: 'line',
        label: 'Conversion Rate (%)',
        data: [26.1, 27.1, 26.3, 26.2, 26.2, 26.4],
        borderColor: '#f59e0b',
        backgroundColor: '#f59e0b',
        borderWidth: 3,
        fill: false,
        tension: 0.4,
        pointBackgroundColor: '#f59e0b',
        pointBorderColor: 'white',
        pointBorderWidth: 2,
        pointRadius: 6,
        yAxisID: 'y1'
      }
    ]
  } as any;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          usePointStyle: true,
          padding: 20,
          color: '#64748b',
          font: {
            size: 12
          }
        }
      },
      tooltip: {
        mode: 'index' as const,
        intersect: false,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        borderColor: 'rgba(0, 0, 0, 0.1)',
        borderWidth: 1,
        cornerRadius: 8,
        padding: 12
      }
    },
    interaction: {
      mode: 'nearest' as const,
      axis: 'x' as const,
      intersect: false
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#94a3b8',
          font: {
            size: 11
          }
        }
      },
      y: {
        type: 'linear' as const,
        display: true,
        position: 'left' as const,
        grid: {
          color: 'rgba(148, 163, 184, 0.1)'
        },
        ticks: {
          color: '#94a3b8',
          font: {
            size: 11
          }
        },
        title: {
          display: true,
          text: 'Volume',
          color: '#64748b',
          font: {
            size: 12
          }
        }
      },
      y1: {
        type: 'linear' as const,
        display: true,
        position: 'right' as const,
        grid: {
          drawOnChartArea: false
        },
        ticks: {
          color: '#94a3b8',
          font: {
            size: 11
          },
          callback: function(value: any) {
            return value + '%';
          }
        },
        title: {
          display: true,
          text: 'Conversion Rate (%)',
          color: '#64748b',
          font: {
            size: 12
          }
        }
      }
    }
  };

  return (
    <div className="h-80">
      <Bar data={data} options={options} />
    </div>
  );
};

export default LoanVolumeConversionChart;